import {FormProvider, useForm} from "react-hook-form";
import {PropsWithChildren, useEffect, useState} from "react";

interface AppFormStateProps {
    formMethods: {};
    formClasses?: string;
    children?: React.ReactNode | (() => React.JSX.Element);
    store: Function;
    storeFormData: string;
}

interface FormStateChildren {
    formMethods: {},
    formClasses?: string,
    children?: React.ReactNode | (() => React.JSX.Element)
    formData: any
}

function AppFormState(props: AppFormStateProps) {
    const [givenMethods, setGivenMethods] = useState(
        {
            ...props.formMethods,
            shouldUnregister: true,
        }
    )

    const { [props.storeFormData]: formData } = props.store?.((state: any) => state)

    useEffect(() => {
        if (props.store && props.storeFormData) {
            setGivenMethods((prev) => ({ ...prev, defaultValues: formData, values: formData }))
        }
    }, []);

    const methods = useForm(givenMethods)
    return <FormProvider {...methods}>
        <AppFormStateChildren
            formClasses={props.formClasses}
            formMethods={methods}
            formData={formData}
        >
            {props.children}
        </AppFormStateChildren>
    </FormProvider>
}

function AppFormStateChildren(props: FormStateChildren) {
    return <form className={props.formClasses || ''}>
        {typeof props.children === 'function' ? (props as any).children(props.formMethods, props.formData) : props.children}
    </form>
}

const labelThemes = {
    'default': 'font-semibold text-sm',
    'blue': 'text-rm-16 font-semibold text-blue-700',
}

AppFormState.Label = function Label({children, theme = 'default'}: PropsWithChildren & {theme?: keyof typeof labelThemes}) {
    return <label className={labelThemes[theme]}>
        {children}
    </label>
}

export default AppFormState
